import 'common/css/app.css'
import './index.css'
import {baseUrl} from 'common/js/global.js'

$(function() {
  summitForm()
  goToShop()
})

function summitForm() {
  // 网页版提交
  $('.sign_up_submit').find('.submit_btn').click(function() {
    var eName = $('#eName').val()
    var ePhone = $('#ePhone').val()
    var eAddress = $('#eAddress').val()
    var remark = $('#remark').val()
    var timer = null
    if(!eName || !ePhone || !eAddress ){
      if (timer) clearTimeout(timer)
      $('#myAlert').find('p').html('请填写完整信息')
      $('#myAlert').show()
      timer = setTimeout(function() {
        $('#myAlert').hide()
      },2000)
    }else{
      var params = {
        eName: eName,
        ePhone: ePhone,
        eAddress: eAddress,
        remark: remark
      }
      sendRequest(params)
    }
  })
  // 手机端提交
  $('.sign_up_submit').find('.submit_btn1').click(function() {
    var eName = $('#eName1').val()
    var ePhone = $('#ePhone1').val()
    var eAddress = $('#eAddress1').val()
    var remark = $('#remark1').val()
    var timer = null
    if(!eName || !ePhone || !eAddress ){
      if (timer) clearTimeout(timer)
      $('#myAlert').find('p').html('请填写完整信息')
      $('#myAlert').show()
      timer = setTimeout(function() {
        $('#myAlert').hide()
      },2000)
    }else{
      var params = {
        eName: eName,
        ePhone: ePhone,
        eAddress: eAddress,
        remark: remark
      }
      sendRequest(params)
    }
  })
}

function sendRequest(params) {
  var timer = null
  $.ajax(baseUrl+ '/api/website/enroll', {
    method:'POST',
    contentType: 'application/json;charset=utf-8',
    data: JSON.stringify(params),
    success : function(data) {
      if(data.errorCode == 0) {
        $('#success-wrapper').find('p').html('感谢您的申请！您的信息已提交成功，稍后我们有专职人员与您接洽！')
        $('#success-wrapper').show()
        $('.sign_up_form').find('input').val("")
        if (timer) clearTimeout(timer)
        timer = setTimeout(function() {
          $('#success-wrapper').hide()
        },2000)
      }else{
        $('#myAlert').find('p').html(data.errorMsg)
        $('#myAlert').show()
        if (timer) clearTimeout(timer)
        timer = setTimeout(function() {
          $('#myAlert').hide()
        },2000)
      }
    }
  })
}
// 跳转到淘宝购买地址
function goToShop () {
  $('.buy_btn').find('button').click(function() {
    window.open(shopUrl)
  })
}
// 小微电站的淘宝购买地址
export const shopUrl = 'https://item.taobao.com/item.htm?id=609771549202'


// WEBPACK FOOTER //
// ./src/miniStation/index.js